import { render, staticRenderFns } from "./OtherLoginMethods.vue?vue&type=template&id=38cd1dba&scoped=true"
import script from "./OtherLoginMethods.vue?vue&type=script&lang=js"
export * from "./OtherLoginMethods.vue?vue&type=script&lang=js"
import style0 from "./OtherLoginMethods.vue?vue&type=style&index=0&id=38cd1dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd1dba",
  null
  
)

export default component.exports